module.exports = __webpack_public_path__ + "static/media/IMG_4878.aa35f91d.JPG";